<!-- Revised on 2025/05/12 by mnavarro -->
<template>
  <div class="dropdown d-inline">
    <Button id="stockProductStatusFilter" color="primary" variant="outline" :title="$t('key_filter_status')" class="dropdown-toggle ms-2 " :class="statusSelected == '' ? '' : 'active-filter'"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-tags me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="stockProductStatusFilter">
      <li>
        <button class="dropdown-item border-radius-md text-calculating" :class="[filterStatusSelected=='0'?'active':'']" type="button" @click="handleClick('0')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-spinner me-3 text-calculating"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_stockProductStatusFilter_calculating') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-stock" :class="[filterStatusSelected=='1'?'active':'']" type="button" @click="handleClick('1')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-cube me-3 text-stock"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_stockProductStatusFilter_stock') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-notavailable" :class="[filterStatusSelected=='2'?'active':'']" type="button" @click="handleClick('2')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-ban me-3 text-notavailable"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_stockProductStatusFilter_not_available') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-outofstock" :class="[filterStatusSelected=='3'?'active':'']" type="button" @click="handleClick('3')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-box-open me-3 text-outofstock"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_stockProductStatusFilter_no_stock') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_stockProductStatusFilter_clear_filters') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

  import Button from "./../../../../generic_components/Button.vue";

  export default {
    name:"StockProductStatusFilter",
    components: {
      Button
    },
    props: {
      filterStatusSelected: {
        type: String,
        default: () => ''
      }
    },
    emits: ['stock-product-status-filter-change'],
    data() {
      return {
        statusSelected: ''
      }
    },
    watch: {
      filterStatusSelected() {
        this.statusSelected = this.filterStatusSelected;
      }
    },
    methods: {
      handleClick(status) {
        this.statusSelected = status;
        this.$emit('stock-product-status-filter-change', status);

        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      }
    }
  }

</script>

<style scoped>

  .active {
    background-color: rgb(234, 244, 247) !important;
  }

  .active-filter {
    color: #fff;
    background-color: #42695c;
    border-color: #42695c;
  }
  
</style>